export function resolveHostUsingEnvironmentInfo(host: string): string {
    // TODO: find a way to standardize this logic for deployed onprem envs
    return host;
}
